// The Development Dashboard guide (21_DevDashboard.jsx · ModuleHelp, Max 01/11).
const en = {
  scopeT: 'What is counted',
  scopeB: 'The line under the title says which samples the figures include — trial samples are left out, which is why a count can differ from the Sample Tracker.',
  kpisT: 'The headline figures',
  kpisB: 'Samples, rounds, rework and lead times for the period at a glance.',
  panelT: 'Breakdowns',
  panelB: 'The same work split by developer, location or stage, to see where the load and the delays are.',
  tableT: 'The detail',
  tableB: 'The rows behind the figures, for checking one developer or one sample.',
};
const ko = {
  scopeT: '집계 기준',
  scopeB: '제목 아래 줄은 수치에 포함된 샘플을 설명합니다. 트라이얼 샘플은 제외되므로 Sample Tracker와 숫자가 다를 수 있습니다.',
  kpisT: '주요 수치',
  kpisB: '기간 내 샘플, 라운드, 재작업, 리드타임을 한눈에 봅니다.',
  panelT: '세부 분석',
  panelB: '같은 작업을 개발자, 위치, 단계별로 나눠 부하와 지연이 어디에 있는지 봅니다.',
  tableT: '상세',
  tableB: '수치의 근거가 되는 행들로, 개발자나 샘플 하나를 확인할 때 씁니다.',
};
const vi = {
  scopeT: 'Những gì được đếm',
  scopeB: 'Dòng dưới tiêu đề cho biết số liệu gồm những sample nào — sample thử (trial) không tính, nên con số có thể khác Sample Tracker.',
  kpisT: 'Số liệu chính',
  kpisB: 'Sample, round, làm lại và thời gian thực hiện trong kỳ, xem nhanh một lần.',
  panelT: 'Phân tích chi tiết',
  panelB: 'Cùng khối việc chia theo developer, địa điểm hoặc giai đoạn, để thấy tải và chậm trễ nằm ở đâu.',
  tableT: 'Chi tiết',
  tableB: 'Các dòng đứng sau số liệu, dùng khi cần kiểm một developer hay một sample.',
};
const zh = {
  scopeT: '统计范围',
  scopeB: '标题下方说明数据包含哪些样品——试验样品不计入，因此数字可能与 Sample Tracker 不同。',
  kpisT: '主要指标',
  kpisB: '一览本期的样品、轮次、返工和周期。',
  panelT: '细分',
  panelB: '按开发人员、地点或阶段拆分同一工作量，查看负荷和延误所在。',
  tableT: '明细',
  tableB: '数字背后的明细行，用于核对某位开发人员或某个样品。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "scopeT": "Ce qui est compté",
  "scopeB": "La ligne sous le titre indique quels échantillons sont inclus dans les chiffres — les échantillons d'essai sont exclus, ce qui explique qu'un total puisse différer de celui du Sample Tracker.",
  "kpisT": "Les chiffres clés",
  "kpisB": "Échantillons, tours, reprises et délais de la période en un coup d'œil.",
  "panelT": "Répartitions",
  "panelB": "Le même travail réparti par développeur, lieu ou étape, pour voir où se situent la charge et les retards.",
  "tableT": "Le détail",
  "tableB": "Les lignes derrière les chiffres, pour vérifier un développeur ou un échantillon."
};
const ja = {
  "scopeT": "集計の対象",
  "scopeB": "タイトルの下の行に、数字に含まれるサンプルが表示されます。トライアルサンプルは除外されるため、Sample Tracker と件数が異なることがあります。",
  "kpisT": "主要な数字",
  "kpisB": "期間中のサンプル、ラウンド、リワーク、リードタイムをひと目で確認できます。",
  "panelT": "内訳",
  "panelB": "同じ作業をデベロッパー、所在地、工程別に分け、負荷と遅延がどこにあるかを確認します。",
  "tableT": "詳細",
  "tableB": "数字の元になった行です。特定のデベロッパーやサンプルを確認するときに使います。"
};

const dictionary = { ns: 'tourDevDash', en, ko, vi, zh, fr, ja };
export default dictionary;
